import { beautifyCamelCaseString } from 'src/app/common/stringUtils';
import { IdentityProvider } from '../api/governance/policy.model';
import { ISelectOption } from './selectOption.interface';

export const IdentityProvidersSelectOptions: ISelectOption[] = [
  {
    id: IdentityProvider.azureActiveDirectory.toString(),
    value: IdentityProvider.azureActiveDirectory.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.azureActiveDirectory),
  },
  {
    id: IdentityProvider.azureActiveDirectoryB2c.toString(),
    value: IdentityProvider.azureActiveDirectoryB2c.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.azureActiveDirectoryB2c),
  },
  {
    id: IdentityProvider.facebook.toString(),
    value: IdentityProvider.facebook.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.facebook),
  },
  {
    id: IdentityProvider.google.toString(),
    value: IdentityProvider.google.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.google),
  },
  {
    id: IdentityProvider.linkedin.toString(),
    value: IdentityProvider.linkedin.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.linkedin),
  },
  {
    id: IdentityProvider.microsoft.toString(),
    value: IdentityProvider.microsoft.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.microsoft),
  },
  {
    id: IdentityProvider.twitter.toString(),
    value: IdentityProvider.twitter.toString(),
    displayName: beautifyCamelCaseString(IdentityProvider.twitter),
  },
];
